import type { Subtask } from '@routes/sidebar/admin-center/creator/___pages___/elements/api/creatorElements.api';

export const mergeSubtasksFromCsvImport = (existingSubtasks: Subtask[], importedSubtasks: Subtask[]): Subtask[] => {
    const merged = [...existingSubtasks];

    importedSubtasks.forEach((importedSubtask) => {
        const existingIndex = merged.findIndex(
            (subtask) => subtask.description.trim().toLowerCase() === importedSubtask.description.trim().toLowerCase(),
        );

        if (existingIndex !== -1) {
            merged[existingIndex] = {
                ...merged[existingIndex],
                guideline: importedSubtask.guideline,
            };

            return;
        }

        merged.push(importedSubtask);
    });

    return merged;
};
